export const translations = {
  fr: {
    hero: {
      title: "Transformez votre business avec l'Intelligence Artificielle",
      subtitle: "Des solutions d'automatisation accessibles et concrètes.",
      description: "Gagnez en efficacité, réduisez vos coûts et concentrez-vous sur l'essentiel.",
      cta: "Réserver ma session gratuite"
    },
    experts: {
      title: "Deux experts, une solution complète",
      roles: {
        strategy: "Stratégie & Automatisation",
        technical: "Expertise Technique"
      }
    },
    solutions: {
      title: "Nos Solutions d'Automatisation",
      sales: {
        title: "Ventes & Prospection",
        items: [
          "Qualification automatique des leads",
          "Chatbots intelligents",
          "Génération de propositions",
          "Outreach LinkedIn optimisé"
        ],
        highlight: "+40% de taux de réponse moyen"
      },
      marketing: {
        title: "Marketing & Contenu",
        items: [
          "Création de contenu assistée",
          "Automatisation sociale",
          "Nurturing personnalisé",
          "Analytics en temps réel"
        ],
        highlight: "Automatisation en 2 semaines"
      },
      bi: {
        title: "Business Intelligence",
        items: [
          "Tableaux de bord sur mesure",
          "Rapports automatisés",
          "Alertes intelligentes",
          "Intégration multi-sources"
        ],
        highlight: "Gagnez 5h par semaine"
      }
    },
    method: {
      title: "Notre Méthode",
      audit: {
        title: "Audit & Roadmap",
        description: "\"Posons les bases de votre succès\""
      },
      implementation: {
        title: "Implémentation",
        description: "\"Des solutions concrètes, rapidement\""
      },
      support: {
        title: "Accompagnement",
        description: "\"Évoluez en toute sérénité\""
      }
    },
    cta: {
      title: "Prêt à automatiser votre business ?",
      subtitle: "Réservez votre session stratégique gratuite de 30 minutes",
      button: "Choisir un créneau"
    }
  },
  en: {
    hero: {
      title: "Transform Your Business with Artificial Intelligence",
      subtitle: "Accessible and concrete automation solutions.",
      description: "Gain efficiency, reduce costs, and focus on what matters most.",
      cta: "Book My Free Session"
    },
    experts: {
      title: "Two Experts, One Complete Solution",
      roles: {
        strategy: "Strategy & Automation",
        technical: "Technical Expertise"
      }
    },
    solutions: {
      title: "Our Automation Solutions",
      sales: {
        title: "Sales & Prospecting",
        items: [
          "Automatic lead qualification",
          "Intelligent chatbots",
          "Proposal generation",
          "Optimized LinkedIn outreach"
        ],
        highlight: "+40% average response rate"
      },
      marketing: {
        title: "Marketing & Content",
        items: [
          "Assisted content creation",
          "Social automation",
          "Personalized nurturing",
          "Real-time analytics"
        ],
        highlight: "Automation in 2 weeks"
      },
      bi: {
        title: "Business Intelligence",
        items: [
          "Custom dashboards",
          "Automated reports",
          "Intelligent alerts",
          "Multi-source integration"
        ],
        highlight: "Save 5h per week"
      }
    },
    method: {
      title: "Our Method",
      audit: {
        title: "Audit & Roadmap",
        description: "\"Building the foundation for your success\""
      },
      implementation: {
        title: "Implementation",
        description: "\"Concrete solutions, quickly\""
      },
      support: {
        title: "Support",
        description: "\"Evolve with peace of mind\""
      }
    },
    cta: {
      title: "Ready to automate your business?",
      subtitle: "Book your free 30-minute strategy session",
      button: "Choose a time slot"
    }
  }
};